import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { destroyAuthSession, setLoggedInUser } from '../redux/slices/session.slice'
import { AppDispatch } from 'redux/store'

import { routes } from 'utils/routes'
import { _object } from 'utils/interfaces'

import { Logo, RightArrows } from 'assets/images'
import ProfileEdit from './profile-edit'
import { initFlowbite } from 'flowbite'
import ChangePassword from './modal/change-password'

const Header = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { isUserLoggedIn, loggedInUser } = useSelector((state: _object) => state.session)

  useEffect(() => {
    isUserLoggedIn && dispatch(setLoggedInUser())
  }, [dispatch, isUserLoggedIn])

  useEffect(() => {
    initFlowbite()
  }, [])

  return (
    <>
      <header className="text-gray bg-purple-900 px-5 py-2 lg:px-8 sticky top-0 z-50">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <h1 className="mr-0">
              <Link to={routes.dashboard}>
                <img src={Logo} alt="Logo" className="w-full" />
              </Link>
            </h1>
            <span className='text-m font-medium text-white mt-12 '>Export</span>
          </div>

          <div className="flex items-center gap-3 lg:gap-4">
            <div className="relative">
              <button
                id="userDropdown"
                data-dropdown-toggle="userDropdownMenu"
                className="flex items-center space-x-3 rounded-lg px-4 py-2 text-sm font-medium text-white hover:bg-purple-800 focus:ring-2 focus:ring-purple-300 focus:outline-none"
              >
                {/* initials avatar: first letter of first and last name (fallback to first letter only) */}
                {(() => {
                  const name = loggedInUser?.full_name || ''
                  const parts = name.trim().split(/\s+/).filter(Boolean)
                  const first = parts[0]?.[0] ?? ''
                  const second = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : ''
                  const initials = (first + second).toUpperCase() || 'U'
                  return (
                    <div className="flex h-7 w-7 items-center justify-center rounded-full bg-white text-purple-900 text-xs font-semibold">
                      {initials}
                    </div>
                  )
                })()}

                <span>
                  {isUserLoggedIn &&
                    (!loggedInUser?.full_name || loggedInUser?.full_name === 'null null')
                    ? 'Hey'
                    : loggedInUser?.full_name}
                </span>

                <img
                  src={RightArrows}
                  alt="Dropdown Arrow"
                  className="h-4 w-4 transition-transform"
                />
              </button>

              <div
                id="userDropdownMenu"
                className="z-10 hidden w-44 divide-y divide-gray-100 rounded-lg bg-white shadow dark:bg-gray-700"
              >
                <ul className="absolute left-0 z-50 mt-2 w-[160px] rounded-md border border-gray-200 bg-white shadow-lg">
                  <li>

                    <button
                      data-modal-target="set-password-modal"
                      data-modal-toggle="set-password-modal"
                      className="w-full px-4 py-2 text-sm hover:bg-purple-100 font-medium"
                      type="button"
                      style={{ textAlign: "start" }}
                    >
                      Change Password
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        if (window.confirm('Do you wish to sign out?')) {
                          dispatch(destroyAuthSession())
                        }
                      }}
                      className="block w-full px-4 py-2 text-start text-sm hover:bg-purple-100"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="profile-edit-modal" aria-hidden="true" className="modal hidden backdrop-blur-sm">
          <ProfileEdit />
        </div>
      </header>
      <ChangePassword />
    </>
  )
}
export default Header
